export default "/images/HDAW_STEP_1.png";